import controller from './allocate-subcase-modal';
import template from './allocate-subcase-modal.pug';

class AllocateSubcaseService {
  /* @ngInject */
  constructor($uibModal, $http) {
    this.$uibModal = $uibModal;
    this.$http = $http;
  }

  open(caseId, subCaseData) {
    return this
      .$uibModal
      .open({
        size: 'md',
        animation: true,
        template,
        controller,
        controllerAs: '$ctrl',
        resolve: {
          caseId: () => caseId,
          subCaseData: () => subCaseData,
        },
      })
      .result;
  }
}

export default AllocateSubcaseService;



// WEBPACK FOOTER //
// ./client/components/allocate-subcase-modal/allocate-subcase-modal.service.js